import {Button} from '@telia/styleguide';
import React, {FC, useState} from 'react';

import {FormState} from '../../hooks/useFormState';
import {useModal} from '../../hooks/useModal';
import {Product, ProductFeature} from '../../model';
import InformationLine from '../common/InformationLine';
import PageSubtitle from '../common/PageSubtitle';
import {FeatureForm} from './FeatureForm';
import {FeaturesTable} from './FeaturesTable';

interface ServiceFeaturesProps {
  formState: FormState;
  onSave: (product: Product) => void;
}

export const ServiceFeatures: FC<ServiceFeaturesProps> = ({formState, onSave}) => {
  const {isEditing, entityAs} = formState;
  const entity = entityAs<Product>();

  const {showModal} = useModal();

  const onUpdate = (feature: ProductFeature) => {
    showModal({
      title: `${feature.id ? 'Edit' : 'Create'}  Feature`,
      content: (
        <FeatureForm
          product={{...entity, features: [...(entity.features || []), ...(!feature.id ? [feature] : [])]}}
          id={feature.id}
          saveCallback={onSave}
        />
      ),
    });
  };

  const onAdd = () => {
    const newFeature = {id: ''} as ProductFeature;
    onUpdate(newFeature);
  };

  return (
    <>
      <hr className="horizontal-rule marginTop2" />
      <PageSubtitle>
        Service Features
        {!isEditing && <Button text="Add feature" className="marginLeft" onClick={onAdd} />}
      </PageSubtitle>
      {entity.features && entity.features.length > 0 ? (
        <FeaturesTable product={entity} showActions={!isEditing} saveCallback={onSave} onUpdate={onUpdate} />
      ) : (
        <InformationLine>No features provisioned yet</InformationLine>
      )}
    </>
  );
};
